import {Cookie} from "../utilities";

if (window.location.href.indexOf('register') == -1 || window.location.href.indexOf('verify') == -1 ){
    Cookie.set('LAST_VISITED_PAGE', document.referrer, false, 1);
}
